import React, { useEffect, useState } from 'react';
import { Pie } from 'react-chartjs-2';
import Loading from '../../../../../components/common/Loading';
import ORBApi from '../../../../../services/ORBApi';
import { GraphGrayColors } from './GraphOptions';

const WorksDSPRevenueGraphs = ({ filters, currency }) => {
	const [dsps, setDsps] = useState([]);
	const [valueDsp, setValueDsp] = useState([]);
	const [fileProcessing, setFileProcessing] = useState(0);
	const [requestSource, setRequestSource] = useState(null);

	const doSearch = () => {
		if (fileProcessing) {
			// if there is a request processing, cancel it
			ORBApi.abortRequest(requestSource);
		}
		setFileProcessing(1);
		// Get the request abort source, to be used to cancel the request if needed
		var cancelRequestSource = ORBApi.getRequestAbortSource();
		setRequestSource(cancelRequestSource);
		ORBApi.loadWorksDspRevenue(
			filters.startDate,
			filters.endDate,
			filters.dateType,
			filters.workId,
			filters.contributorId,
			filters.publisher,
			cancelRequestSource
		)
			.then((data) => {
				if (!data || !data.dsps) {
					setDsps([]);
					setValueDsp([]);
					setFileProcessing(0);
					return;
				}
				setDsps(data.dsps.map((i) => i?.dsp || 'N/A'));
				setValueDsp(data.dsps.map((i) => i?.value || 0));
				setFileProcessing(0);
			})
			.catch((error) => {
				if (!ORBApi.isCancel(error)) {
					// When cancelling the request, do not remove the "loading"
					setFileProcessing(0);
				}
			});
	};

	useEffect(() => {
		doSearch();
	}, [filters]);

	return (
		<div>
			{fileProcessing ? (
				<Loading className='file-loading-container' />
			) : dsps.length === 0 ? (
				<div style={{ textAlign: 'center', padding: '20px' }}>
					Sem dados para exibir
				</div>
			) : (
				<Pie
					options={{
						plugins: {
							tooltip: {
								callbacks: {
									label: function (context) {
										var dsp = context.label;
										var value = context.parsed.toLocaleString('pt-br', {
											style: 'currency',
											currency: currency,
											maximumFractionDigits: 1,
										});
										return dsp + ' ' + value;
									},
								},
							},
						},
					}}
					data={{
						labels: dsps,
						datasets: [
							{
								data: valueDsp,
								backgroundColor: GraphGrayColors,
							},
						],
					}}
				/>
			)}
		</div>
	);
};

export default WorksDSPRevenueGraphs;
